var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list', {
    staticClass: "overflow-y-auto"
  }, [_c('v-list-item', {
    attrs: {
      "to": "/"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-home")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Home')))])], 1)], 1), _c('v-divider'), _c('v-subheader', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v(_vm._s(_vm.$t('Battle')))]), _c('v-list-item', {
    attrs: {
      "to": "/characters"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-cards")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Characters')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/weapons"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-sword")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Weapons')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/questlibraries"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-sword-cross")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Quests')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/master"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-chess-queen")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Master')) + " ")])], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/abilitytreefruits"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-food-apple")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('AbilityTreeFruits')) + " ")])], 1)], 1), _c('v-divider'), _c('v-subheader', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v(_vm._s(_vm.$t('Items')))]), _c('v-list-item', {
    attrs: {
      "to": "/items"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-flower-poppy")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Items')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/roomobjects"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-seat")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Room Objects')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/townobjects"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-castle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Town Objects')))])], 1)], 1), _c('v-divider'), _c('v-subheader', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v(_vm._s(_vm.$t('Library')))]), _c('v-list-item', {
    attrs: {
      "to": "/titles"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-book")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Titles')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/scenariolibraries"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-book-open-page-variant")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Scenarios')))])], 1)], 1), _c('v-divider'), _c('v-subheader', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v(_vm._s(_vm.$t('Others')))]), _c('v-menu', {
    attrs: {
      "top": "",
      "offset-x": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-list-item', _vm._g({}, on), [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-link")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Tools')))])], 1), _c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)];
      }
    }])
  }, [_c('v-list', {
    staticClass: "overflow-y-auto",
    staticStyle: {
      "max-height": "calc(100vh - 24px)"
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('Applications')))]), _c('v-list-item', {
    attrs: {
      "href": _vm.$const.sites.calculator,
      "target": "_blank"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-calculator")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Calculator.Title')))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Calculator.Subtitle')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "href": _vm.$const.sites.assets,
      "target": "_blank"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-image")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Assets.Title')))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Assets.Subtitle')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "href": _vm.$const.sites.cardmaker,
      "target": "_blank"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-cards-outline")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Card Maker.Title')))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Card Maker.Subtitle')))])], 1)], 1), _c('v-divider'), _c('v-subheader', [_vm._v(_vm._s(_vm.$t('External Links')))]), _c('v-list-item', {
    attrs: {
      "href": _vm.$const.sites.yarudesu,
      "target": "_blank"
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Yarudesu.Title')))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Yarudesu.Subtitle')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "href": _vm.$const.sites.wikiwiki,
      "target": "_blank"
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Wikiwiki.Subtitle')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "href": _vm.$const.sites.moegirl,
      "target": "_blank"
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Moegirl.Title')))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Moegirl.Subtitle')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "href": _vm.$const.sites.miraheze,
      "target": "_blank"
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Miraheze.Title')))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Miraheze.Subtitle')))])], 1)], 1), _c('v-list-item', {
    attrs: {
      "href": _vm.$const.sites.timer,
      "target": "_blank"
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Timers.Title')))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Timers.Subtitle')))])], 1)], 1)], 1)], 1), _c('v-list-item', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "to": "/settings"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-cog")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Settings')))])], 1)], 1), _c('v-menu', {
    attrs: {
      "top": "",
      "offset-x": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-list-item', _vm._g({
          staticClass: "hidden-xs-only"
        }, on), [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-cog")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Settings')))])], 1), _c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)];
      }
    }])
  }, [_c('v-list', {
    staticClass: "overflow-y-auto",
    staticStyle: {
      "max-height": "calc(100vh - 24px)"
    }
  }, [_c('Settings')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }